import { render, staticRenderFns } from "./MemberScoreComponent.vue?vue&type=template&id=b369008a&"
import script from "./MemberScoreComponent.vue?vue&type=script&lang=js&"
export * from "./MemberScoreComponent.vue?vue&type=script&lang=js&"
import style0 from "./MemberScoreComponent.vue?vue&type=style&index=0&id=b369008a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports